'use client';

import React, { useState } from 'react';
import AuthBrandPanel from './AuthBrandPanel';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';

export type AuthTab = 'login' | 'signup';

export default function AuthContainer() {
  const [activeTab, setActiveTab] = useState<AuthTab>('login');

  return (
    <div className="min-h-screen flex">
      {/* Left brand panel — hidden on mobile */}
      <AuthBrandPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 bg-background min-h-screen">
        <div className="w-full max-w-md animate-fade-in">
          {/* Mobile logo */}
          <div className="flex items-center gap-3 mb-8 lg:hidden">
            <div className="w-9 h-9 gradient-primary rounded-xl flex items-center justify-center shadow-primary-glow">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect x="2" y="12" width="3" height="6" rx="1" fill="white" fillOpacity="0.7" />
                <rect x="7" y="8" width="3" height="10" rx="1" fill="white" fillOpacity="0.85" />
                <rect x="12" y="4" width="3" height="14" rx="1" fill="white" />
                <circle cx="15.5" cy="3" r="1.5" fill="var(--accent)" />
              </svg>
            </div>
            <span className="text-xl font-bold text-foreground tracking-tight">FinanceTracker</span>
          </div>

          {/* Tab switcher */}
          <div className="flex bg-muted rounded-xl p-1 mb-8">
            <button
              onClick={() => setActiveTab('login')}
              className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 ${
                activeTab === 'login' ?'bg-card text-foreground shadow-card' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 ${
                activeTab === 'signup' ?'bg-card text-foreground shadow-card' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Create Account
            </button>
          </div>

          {/* Forms */}
          <div className="animate-scale-in" key={activeTab}>
            {activeTab === 'login' ? (
              <LoginForm onSwitchToSignup={() => setActiveTab('signup')} />
            ) : (
              <SignUpForm onSwitchToLogin={() => setActiveTab('login')} />
            )}
          </div>

          {/* Privacy note */}
          <p className="text-center text-xs text-muted-foreground mt-8">
            🔒 Your financial data is stored locally and never shared with third parties.
          </p>
        </div>
      </div>
    </div>
  );
}